import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as rcc from "../../constants/rcc";
import * as rccHelper from "../../helpers/rccResponseHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as changelogService from "../changelogService";
import * as initDataService from "./initDataService";

export const processWebsocketResponse = (tabId, method, response, next, state) => {
    switch (method) {
        case handlers.RCC_GET_VERSION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    messageHelper.getRccFlashMessage(response),
                    {
                        type: actionTypes.RCC_DISCONNECT
                    },
                    {
                        type: actionTypes.RCC_INITIALIZED
                    }
                ];
            }

            if (response.result === resultCodes.RCC_RESULT_OK && rccHelper.checkRccVersion(response)) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_IS_SELECTED
                        },
                        method: handlers.MACHINE_IS_SELECTED,
                        tabId: 0,
                        safe: false
                    },
                    {
                        type: actionTypes.RCC_SPECTRO_REQUEST,
                        payload: {
                            type: methods.METHOD_SPECTRO_IS_SELECTED
                        },
                        method: handlers.SPECTRO_IS_SELECTED,
                        tabId: 0,
                        safe: false
                    },
                    {
                        type: actionTypes.RCC_SIMPLE_REQUEST,
                        payload: {
                            type: methods.METHOD_PRINTER_GET_DEFAULT
                        },
                        method: handlers.PRINTER_GET_DEFAULT,
                        tabId: 0
                    },
                    {
                        type: actionTypes.RCC_SIMPLE_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_DRIVER_TYPES
                        },
                        method: handlers.GET_DRIVER_TYPES,
                        tabId: 0
                    },
                    {
                        type: actionTypes.RCC_SIMPLE_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_SPECTRO_TYPES
                        },
                        method: handlers.GET_SPECTRO_TYPES,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.RCC_DISCONNECT
                },
                {
                    type: actionTypes.RCC_INITIALIZED
                },
                messageHelper.getInfoMessageAction("flashMessage.wrongRccVersion", [
                    changelogService.getLastRccVersion()
                ])
            ];
        case handlers.MACHINE_IS_SELECTED:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.MACHINE_INITIALIZED
                    },
                    messageHelper.getRccFlashMessage(response)
                ];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.MACHINE_SET_SELECTION,
                        payload: {
                            selected: true
                        }
                    },
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_IS_CONNECTED
                        },
                        method: handlers.MACHINE_IS_CONNECTED,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_INITIALIZED
                },
                {
                    type: actionTypes.MACHINE_SET_SELECTION,
                    payload: {
                        selected: false
                    }
                }
            ];
        case handlers.MACHINE_IS_CONNECTED:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.MACHINE_SET_CONNECTION,
                        payload: {
                            connected: true
                        }
                    },
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_IS_BUSY
                        },
                        method: handlers.INIT_MACHINE_IS_BUSY,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_IS_CONNECTING
                    },
                    method: handlers.MACHINE_IS_CONNECTING,
                    tabId: 0,
                    safe: false
                },
                {
                    type: actionTypes.MACHINE_INITIALIZED
                }
            ];
        case handlers.MACHINE_IS_CONNECTING:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                        payload: {
                            id: response.sequence,
                            tabId: 0,
                            method: methods.MACHINE_EVENT_CONNECT_DONE
                        }
                    }
                ];
            }

            if (state.rcc.machine.typeName === rcc.DRIVER_TYPE_NONE) {
                return [
                    {
                        type: actionTypes.MACHINE_SET_CONNECTION,
                        payload: {
                            connected: false
                        }
                    },
                    {
                        type: actionTypes.MACHINE_INITIALIZED
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_START_CONNECT
                    },
                    method: handlers.MACHINE_START_CONNECT,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.INIT_MACHINE_IS_BUSY:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.MACHINE_INITIALIZED
                    },
                    messageHelper.getRccFlashMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_BUSY,
                    payload: {
                        isBusy: response.data
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CALLS
                    },
                    method: handlers.MACHINE_GET_CALLS,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.MACHINE_GET_CALLS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.MACHINE_INITIALIZED
                    },
                    messageHelper.getRccFlashMessage(response)
                ];
            }

            let machineMethods = rccHelper.processMethodList(response.data);

            let machineRequests = [
                {
                    type: actionTypes.SAVE_MACHINE_CALLS,
                    payload: {
                        methods: machineMethods
                    }
                }
            ];

            if (machineMethods[methods.METHOD_MACHINE_INFO] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_INFO
                    },
                    method: handlers.INIT_MACHINE_INFO,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_DEVICES] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_DEVICES
                    },
                    method: handlers.INIT_MACHINE_DEVICES,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_CANISTERS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.INIT_MACHINE_CANISTERS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_CHANNELS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CHANNELS
                    },
                    method: handlers.INIT_MACHINE_CHANNELS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (!state.rcc.machine.isBusy && machineMethods[methods.METHOD_MACHINE_GET_ERRORS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_ERRORS
                    },
                    method: handlers.INIT_MACHINE_ERRORS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (!state.rcc.machine.isBusy && machineMethods[methods.METHOD_MACHINE_GET_SENSORS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_SENSORS
                    },
                    method: handlers.INIT_MACHINE_SENSORS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_HISTORY_LAST_ACTIONS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_HISTORY_LAST_ACTIONS
                    },
                    method: handlers.INIT_MACHINE_HISTORY,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_GET_AVAILABLE_AUTOTASK_TYPES] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_AVAILABLE_AUTOTASK_TYPES
                    },
                    method: handlers.INIT_MACHINE_AUTOTASK_TYPES,
                    tabId: 0,
                    safe: false
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_GET_AUTOTASKS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_AUTOTASKS
                    },
                    method: handlers.INIT_MACHINE_AUTOTASKS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_PURGE_RULES_LIST] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_PURGE_RULES_LIST
                    },
                    method: handlers.INIT_MACHINE_PURGE_RULES,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            if (machineMethods[methods.METHOD_MACHINE_CANISTER_BATCH_NUMBERS] === true) {
                machineRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTER_BATCH_NUMBERS
                    },
                    method: handlers.INIT_MACHINE_CAN_BATCH_NUMBERS,
                    tabId: 0,
                    safe: true
                });
            } else {
                machineRequests.push({type: actionTypes.INCREASE_LOADING});
            }

            return machineRequests;
        case handlers.SPECTRO_IS_SELECTED:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_SELECT,
                    payload: {
                        result: response.data === true
                    }
                }
            ];
        case handlers.PRINTER_GET_DEFAULT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                if (state.settings.printEnabled) {
                    return [
                        {
                            type: actionTypes.PRINTER_INITIALIZED
                        },
                        messageHelper.getRccFlashMessage(response)
                    ];
                }

                return [
                    {
                        type: actionTypes.PRINTER_INITIALIZED
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_DEFAULT_PRINTER,
                    payload: {
                        name: typeof response.data !== "string" ? "" : response.data
                    }
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_PRINTER_GET_PRINTERS_LIST
                    },
                    method: handlers.INIT_PRINTER_PRINTERS_LIST,
                    tabId: 0
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_PRINTER_GET_TEMPLATES_LIST
                    },
                    method: handlers.INIT_PRINTER_TEMPLATES_LIST,
                    tabId: 0
                }
            ];
        case handlers.GET_DRIVER_TYPES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.DRIVERS_INITIALIZED
                    },
                    messageHelper.getRccFlashMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_DRIVER_TYPES,
                    payload: {
                        driverTypesList: response.data
                    }
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DRIVER_CONFIGURATION
                    },
                    method: handlers.INIT_DRIVER_CONFIGURATION,
                    tabId: 0
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CONFIGURATION
                    },
                    method: handlers.INIT_MACHINE_CONFIGURATION,
                    tabId: 0
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_RCC_SET_COLORANTS,
                        params: {
                            value: rccHelper.mapColorantListForRcc(state.global.allColorantList)
                        }
                    },
                    method: handlers.INIT_RCC_COLORANTS,
                    tabId: 0
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_UNITS
                    },
                    method: handlers.INIT_MACHINE_UNITS,
                    tabId: 0
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_MESSAGES
                    },
                    method: handlers.INIT_MACHINE_MESSAGES,
                    tabId: 0
                }
            ];
        case handlers.GET_SPECTRO_TYPES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.SPECTRO_INITIALIZED
                    },
                    messageHelper.getRccFlashMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_TYPES,
                    payload: {
                        typeList: response.data
                    }
                },
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SPECTRO_CONFIGURATION
                    },
                    method: handlers.INIT_SPECTRO_CONFIGURATION,
                    tabId: 0
                }
            ];
        case handlers.INIT_MACHINE_INFO:
        case handlers.INIT_MACHINE_DEVICES:
        case handlers.INIT_MACHINE_CANISTERS:
        case handlers.INIT_MACHINE_CHANNELS:
        case handlers.INIT_MACHINE_ERRORS:
        case handlers.INIT_MACHINE_SENSORS:
        case handlers.INIT_MACHINE_HISTORY:
        case handlers.INIT_MACHINE_UNITS:
        case handlers.INIT_MACHINE_MESSAGES:
        case handlers.INIT_MACHINE_AUTOTASK_TYPES:
        case handlers.INIT_MACHINE_AUTOTASKS:
        case handlers.INIT_MACHINE_PURGE_RULES:
        case handlers.INIT_PRINTER_PRINTERS_LIST:
        case handlers.INIT_PRINTER_TEMPLATES_LIST:
        case handlers.INIT_DRIVER_CONFIGURATION:
        case handlers.INIT_MACHINE_CONFIGURATION:
        case handlers.INIT_RCC_COLORANTS:
        case handlers.INIT_SPECTRO_CONFIGURATION:
        case handlers.INIT_MACHINE_CAN_BATCH_NUMBERS:
            return initDataService.processWebsocketResponse(method, response, state).concat([
                {
                    type: actionTypes.INCREASE_LOADING
                }
            ]);
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
